import { Form, Switch, Typography } from 'antd';

import { ExtendedMessage } from '@app/components';
import { PREFIX as GLOBAL_PREFIX } from '@app/constants/appPrefix';
import type { NRecordReminders } from '@app/types';

import { LabelWithTime } from '@pages/Notifications/components/LabelWithTime';
import { ReminderFiles } from '@pages/Notifications/components/ReminderFiles';

import type { FormInstance } from 'antd';
import type { FC } from 'react';

import '@pages/Notifications/styles/FeedbackRequest.desktop.scss';

const { Title } = Typography;
const { useWatch } = Form;

export const FeedbackRequest: FC<{
  form: FormInstance;
  reminder: NRecordReminders.ModelRecordReminder | null;
  disabled?: boolean;
}> = ({ form, reminder, disabled = false }) => {
  const COMPONENT_CLASS_NAME = `${GLOBAL_PREFIX}feedback-request`;

  const hoursValue = form.getFieldValue('feedbackIntervalHours') || 0;
  const minutesValue = form.getFieldValue('feedbackIntervalMinutes') || 0;
  const handleHoursChange = (value: number) => {
    form.setFieldsValue({ feedbackIntervalHours: value });
  };
  const handleMinutesChange = (value: number) => {
    form.setFieldsValue({ feedbackIntervalMinutes: value });
  };

  const isFeedbackStatus = useWatch('feedbackStatus', form);

  return (
    <div className={COMPONENT_CLASS_NAME}>
      <div className={`${COMPONENT_CLASS_NAME}__header-row`}>
        <Title
          level={4}
          className={`${COMPONENT_CLASS_NAME}__header`}
          data-testid="notification-of-visit-block-title"
        >
          Уведомление о состоявшемся визите и запрос отзыва
        </Title>
        <div className={`${COMPONENT_CLASS_NAME}__switch-wrap`}>
          <Form.Item
            name="feedbackStatus"
            className={`${COMPONENT_CLASS_NAME}__switch`}
          >
            <Switch
              data-testid={
                form.getFieldValue('createRecordStatus')
                  ? 'active-notification'
                  : 'inactive-notification'
              }
              disabled={disabled}
            />
          </Form.Item>
        </div>
      </div>

      {isFeedbackStatus && (
        <>
          <div
            className={`${COMPONENT_CLASS_NAME}__description`}
            data-testid="notification-of-visit-description"
          >
            Настройте сообщение, отправляемое клиенту в WhatsApp после окончания
            визита (после проведения оплаты).
          </div>

          <LabelWithTime
            componentClassName={COMPONENT_CLASS_NAME}
            type="after"
            minutesFormItemName="feedbackIntervalMinutes"
            hoursFormItemName="feedbackIntervalHours"
            onHoursChange={handleHoursChange}
            onMinutesChange={handleMinutesChange}
            hoursValue={hoursValue}
            minutesValue={minutesValue}
            withExtendedHours
            disabled={disabled}
          />

          <div
            className={`${COMPONENT_CLASS_NAME}__label`}
            data-testid="notification-title"
          >
            Текст уведомления
          </div>
          <ExtendedMessage
            form={form}
            socialType="whatsapp"
            formItemName="feedbackMessage"
            formItemClassName={`${COMPONENT_CLASS_NAME}__textarea`}
            textAreaDataTestId="notification-template-text"
            disabled={disabled}
          />

          <ReminderFiles
            reminder={reminder}
            componentClassName={COMPONENT_CLASS_NAME}
            disabled={disabled}
          />
        </>
      )}
    </div>
  );
};
